import styled, { css } from 'styled-components'
import { Paragraph, Heading } from '../../atoms/Typography/Typography.styles';

interface LineProps {
  theme: any;
}

export const Line = styled.div<LineProps>`
  width: 100%;
  padding-bottom: ${({ theme }) => theme.rem(24)};
  border-top: 1px solid;

  ${({ theme }) => theme.mediaQuery.lg(`
    padding-bottom: ${theme.rem(40)};
  `)}
`

interface TextImageProps {
  theme: any;
  colorScheme: string;
  withBackground?: boolean;
}

export const TextImage = styled.div<TextImageProps>`
  color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`].surface.text.base.primary};

  a {
    width: 100%;
  }

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme, withBackground }) => withBackground ? theme.colorScheme[`${colorScheme}`].surface.text.base.negative : 'black'};
  }
`

interface ImageWrapperProps {
  theme: any;
}

export const ImageWrapper = styled.div<ImageWrapperProps>`
  width: 100%;
  position: relative;
  aspect-ratio: 4 / 3;
  border-radius: ${({ theme }) => theme.rem(8)};
  overflow: hidden;

  img {
    object-fit: cover;
    object-position: center;
  }
`
